module.exports = __webpack_public_path__ + "static/media/importICloud2.a50dc3a7.png";